<app-navbar></app-navbar>
<div class="container mt-5">
    <h3><img src="../../../assets/img/perfil.png" width="70" alt="">Perfil de Usuario: <b>{{usrType}}</b></h3>
    <hr>
    <br>
    <div class="col-12">
        <div class="row">
            <div class="col-5">
                <h4><img src="../../../assets/img/usuario.png" width="25" alt=""> Nombre:</h4>
            </div>
            <div class="col-5 mt-1">
                <h4><b>{{nombre | titlecase}}</b></h4>
            </div>
            <div class="col-2">
                <button title="Actualizar el nombre" class="btn btn-danger" (click)="activateUpdate('name')" data-toggle="modal" data-target="#perfilUser"><i class="fa fa-edit"></i></button>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-5">
                <h4><img src="../../../assets/img/id-card.svg" width="25" alt=""> Identificación:</h4>
            </div>
            <div class="col-5 mt-1">
                <h4><b>{{cedula}}</b></h4>
            </div>
            <div class="col-2">
                <button title="Editar el número de cédula" class="btn btn-danger" (click)="activateUpdate('cdl')" data-toggle="modal" data-target="#perfilUser"><i class="fa fa-edit"></i></button>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-5">
                <h4><img src="../../../assets/img/email.png" width="25" alt=""> Correo Electrónico:</h4>
            </div>
            <div class="col-5 mt-1">
                <h4><b>{{email}}</b></h4>
            </div>
            <div class="col-2">
                <button title="Editar el email" class="btn btn-danger" (click)="activateUpdate('mail')" data-toggle="modal" data-target="#perfilUser"><i class="fa fa-edit"></i></button>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-5">
                <h4><img src="../../../assets/img/phone.svg" width="25" alt=""> Número de telefónico:</h4>
            </div>
            <div class="col-5 mt-1">
                <h4><b>{{telefono}}</b></h4>
            </div>
            <div class="col-2">
                <button title="Editar el email" class="btn btn-danger" (click)="activateUpdate('tel')" data-toggle="modal" data-target="#perfilUser"><i class="fa fa-edit"></i></button>
            </div>
        </div>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="perfilUser" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Actualizar Datos de Perfil</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <div *ngIf="name" class="form-group">
                    <label for="exampleInputEmail1">Nombre:</label>
                    <input type="text" class="form-control" (change)="nuevoNombre($event.target.value)">
                </div>
                <div *ngIf="cdl" class="form-group">
                    <label for="exampleInputPassword1">Identificación:</label>
                    <input type="number" class="form-control" (change)="nuevoCedula($event.target.value)">
                </div>
                <div *ngIf="mail" class="form-group">
                    <label for="exampleInputPassword1">Correo Electrónico:</label>
                    <input type="mail" class="form-control" aria-describedby="emailHelp" (change)="nuevoEmail($event.target.value)">
                </div>
                <div *ngIf="tel" class="form-group">
                    <label for="exampleInputPassword1">Número Telefónico:</label>
                    <input type="number" class="form-control" (change)="nuevoTelefono($event.target.value)">
                </div>
                <div class="form-group">
                    <button class="btn btn-danger btn-block" (click)="actualizaDatos()" data-dismiss="modal">Actualizar Datos</button>
                </div>
            </div>
        </div>
    </div>
</div>